import { render, staticRenderFns } from "./ActivationItem.vue?vue&type=template&id=2c9fb77c&"
import script from "./ActivationItem.vue?vue&type=script&lang=ts&"
export * from "./ActivationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports